// extracted by mini-css-extract-plugin
export default {"whatsapp":"Whatsapp_whatsapp__iIYdF","icon":"Whatsapp_icon__5wciv"};